import React, { useState } from "react";
import NotificationDialog from "../shared/NotificationDialog";
import * as Actions from "../../store/actions";
import Button from "../shared/Button";
import { AppPaths } from "../../constants/urls";
import { EntryValue, UrlParam } from "../../constants/urlParams";
import styled from "styled-components/macro";

export interface DisconnectedFromNativeDialogProps {
    isOpen: boolean;
}

export default function DisconnectedFromNativeDialog(props: DisconnectedFromNativeDialogProps): JSX.Element {
    const [buttonEnabled, setButtonEnabled] = useState(true);

    const launchWithoutVS = (): void => {
        setButtonEnabled(false);

        const loc = window.location;
        const params = new URLSearchParams(loc.search);
        params.delete("port");
        params.delete("fsid");
        const paramsString: string = params?.toString();
        let newPath = loc.pathname;
        if (newPath === AppPaths.report) {
            newPath = AppPaths.myfeedback;
        }
        Actions.clearGlobalNotification();
        window.location.replace(`${newPath}?${paramsString}`);

    };

    return <NotificationDialog
        notificationType={"error"}
        isOpen={props.isOpen}
        title={"Disconnected from Visual Studio"}
        isCritical={true}
        canDismiss={false}
    >
        <Wrapper>
            <div className="title">Oops, we have lost the connection to Visual Studio.</div>
            <br />
            <div className="description">
                <div>You have two choices:</div>
                <ul>
                    <li>
                        <b>Relaunch this page from Visual Studio.&nbsp;</b>
                        This is required if you want to report new feedback for Visual Studio.</li>
                    <li>
                        <b>Launch this page without Visual Studio.&nbsp;</b>
                        You would still be able to do everything else except report new feedback for Visual Studio. Click the button below to do that.
                    </li>
                </ul>
            </div>

            <div className="buttons">
                <Button disabled={!buttonEnabled} onClick={launchWithoutVS}>Launch without Visual Studio</Button>
            </div>
        </Wrapper>
    </NotificationDialog>
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 3rem 2rem 2rem 2rem;
    line-height: 3rem;

    .title {
        font-size: 1.8rem;
    }

    .description {
        margin-bottom: 4rem;
    }

    .buttons {
        display: flex;
        justify-content: center;
    }

    ul {
        padding-left: 5rem;
    }

    li {
        display: list-item;
    }
`;
